import cx from "classnames";

import { useSelector } from "redux/hooks";
import { getCartTypeLabel } from "redux/selectors/cart";
import { getOrderCartLabel } from "redux/selectors/order";

type Props = {
  className?: string;
  cartSource?: "cart" | "order";
};

const CartTypeLabel = ({ className, cartSource = "cart" }: Props) => {
  const cartLabel = useSelector(getCartTypeLabel);
  const orderLabel = useSelector(getOrderCartLabel);
  const label = cartSource === "cart" ? cartLabel : orderLabel;

  if (!label) {
    return null;
  }

  const labelClassName = cx(
    "text-xs rounded font-bold px-sm border border-light-grey leading-normal inline-block",
    className,
  );

  return (
    <div className={labelClassName} data-testid="cart-type-label">
      {label}
    </div>
  );
};

export default CartTypeLabel;
